import React from 'react';
import { earlyCareer, timeline } from '../data/profile';
import { SectionHeading } from '../components/SectionHeading';
import { IndustryBackdrop } from '../components/IndustryBackdrop';
export function Career() {
  return <section className="relative min-h-[70vh] overflow-hidden bg-parchment pt-32 pb-24 lg:pb-32" data-id="element-71" data-mp="2l8e6bytizv5v">
      <IndustryBackdrop data-id="element-72" data-mp="2g9tgmtbwgtvo" />
      <div className="relative mx-auto max-w-[1400px] px-6 lg:px-10" data-id="element-73" data-mp="2gal23bbs9b88">
        <SectionHeading eyebrow="CAREER MILESTONES" title="Three decades of sourcing leadership" intro="A progression from contract controls in data centre operations to enterprise wide Source to Pay transformation at a global financial institution." data-id="element-74" data-mp="3cxhc5j129dkm" />

        <ol className="mt-16 space-y-14" data-id="element-75" data-mp="2z6b7l8ixcpqv">
          {timeline.map(entry => <li key={entry.company} className="grid gap-8 lg:grid-cols-[280px_1fr] lg:gap-14" data-id="element-76" data-mp="hvrr4sa6k4j">
              <div className="lg:sticky lg:top-28 lg:self-start" data-id="element-77" data-mp="3rvi1tvbcit6b">
                <p className="text-sm tracking-wider2 text-gold-500" data-id="element-78" data-mp="3ru70011gnvhu">{entry.period}</p>
                <h3 className="mt-2 text-3xl text-ink" data-id="element-79" data-mp="x82bic7mri2l">{entry.company}</h3>
                <p className="mt-2 text-base text-slate-500" data-id="element-80" data-mp="123r4fwp5a0px">{entry.sector}</p>
              </div>

              <ul className="border-l border-ink/15 pl-8 lg:pl-12" data-id="element-81" data-mp="ocw1t258ofus">
                {entry.roles.map((role, roleIndex) => <li key={role.role} className={`relative ${roleIndex === 0 ? '' : 'mt-10'}`} data-id="element-82" data-mp="sd64a4ttoo4w" data-mpi={roleIndex}>
                    <span aria-hidden="true" className="absolute -left-[2.3rem] top-2 h-3 w-3 border border-grass-600 bg-grass-500 lg:-left-[3.4rem]" data-id="element-83" data-mp="ehkkqd6cywjv" />
                    <h4 className="text-xl text-ink" data-id="element-84" data-mp="9gequc0yp38r">{role.role}</h4>
                    <p className="mt-1 text-base text-grass-700" data-id="element-85" data-mp="9goie41nnigk">
                      {role.span} · {role.place}
                    </p>
                    <p className="mt-3 max-w-3xl text-base leading-relaxed text-slate-600" data-id="element-86" data-mp="23u5wz1k314zg">
                      {role.copy}
                    </p>
                  </li>)}
              </ul>
            </li>)}
        </ol>

        <div className="mt-20 border-t border-ink/15 pt-10" data-id="element-87" data-mp="37qq4qvrfqmog">
          <h3 className="text-sm tracking-wider2 text-grass-600" data-id="element-88" data-mp="33q677r2y9h1s">EARLY CAREER, UNITED KINGDOM</h3>
          <ul className="mt-8 grid gap-10 md:grid-cols-2" data-id="element-89" data-mp="2ys4pb9h9fnrw">
            {earlyCareer.map(role => <li key={role.company} className="flex flex-col" data-id="element-90" data-mp="3vido8smdavgp">
                <h4 className="text-2xl text-ink" data-id="element-91" data-mp="3vjot6vrju99e">{role.company}</h4>
                <p className="mt-1 text-lg text-slate-700" data-id="element-92" data-mp="3rgshlp0ffdey">{role.role}</p>
                <p className="mt-1 text-base text-grass-700" data-id="element-93" data-mp="3moqvzchdcac9">
                  {role.span} · {role.place}
                </p>
                <p className="mt-3 text-base leading-relaxed text-slate-600" data-id="element-94" data-mp="3hpxsmcvspzpt">{role.copy}</p>
              </li>)}
          </ul>
        </div>
      </div>
    </section>;
}